import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../utils/auth';
import { CircularProgress } from '@mui/material';

function PublicRoute({ children }) {
  const [auth, setAuth] = useState(null);

  useEffect(() => {
    async function checkAuth() {
      const result = await isAuthenticated();
      setAuth(result);
    }
    checkAuth();
  }, []);

	if (auth === null) {
	  return (
		<div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
		  <CircularProgress />
		</div>
	  );
	}

  return auth ? <Navigate to="/dashboard" /> : children;
}

export default PublicRoute;
